'use client'

import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

import { trackPageViewed } from '@/lib/analytics/events'

const PAGE_NAMES: Record<string, string> = {
  '/': 'Home',
  '/idea-management': 'Gestão de iniciativas',
  '/idea-management/kanban': 'Funil de iniciativas',
  '/idea-management/[id]': 'Detalhe de iniciativa',
  '/idea-management/dashboard': 'Painel de dados',
  '/idea-management/ranking': 'Ranking',
  '/idea-management/feed': 'Feed de iniciativas',
  '/idea-management/idea-list': 'Lista de iniciativas',
  '/idea-management/published-challenges': 'Desafios publicados',
  '/idea-management/published-challenges/[id]': 'Detalhe do desafio',
  '/idea-management/challenge-management': 'Gestão de desafios',
  '/idea-management/challenge-management/[id]': 'Editar desafio',
  '/projects/portfolio/[id]': 'Portfólio de projetos',
  '/projects/portfolio/[id]/[projectId]': 'Detalhe do projeto',
  '/profile': 'Perfil',
  '/profile/update': 'Editar perfil',
  '/profile/my-ideas/[id]': 'Minha iniciativa',
  '/profile/my-project/[projectId]': 'Meu projeto',
  '/admin-portal': 'Portal admin',
  '/notifications': 'Notificações',
  '/knowledge-trail': 'Trilha de conhecimento',
  '/open-innovation': 'Open innovation',
}

function normalizePath(pathname: string): string {
  return pathname
    .replace(
      /\/idea-management\/(?!kanban|dashboard|ranking|feed|idea-list|published-challenges|challenge-management)[^/]+$/,
      '/idea-management/[id]',
    )
    .replace(
      /\/idea-management\/published-challenges\/[^/]+$/,
      '/idea-management/published-challenges/[id]',
    )
    .replace(
      /\/idea-management\/challenge-management\/[^/]+$/,
      '/idea-management/challenge-management/[id]',
    )
    .replace(
      /\/projects\/portfolio\/[^/]+\/[^/]+$/,
      '/projects/portfolio/[id]/[projectId]',
    )
    .replace(/\/projects\/portfolio\/[^/]+$/, '/projects/portfolio/[id]')
    .replace(/\/profile\/my-ideas\/[^/]+$/, '/profile/my-ideas/[id]')
    .replace(/\/profile\/my-project\/[^/]+$/, '/profile/my-project/[projectId]')
}

export function PageTracker() {
  const pathname = usePathname()

  useEffect(() => {
    const normalized = normalizePath(pathname)
    const page_type = PAGE_NAMES[normalized] ?? normalized
    trackPageViewed(page_type)
  }, [pathname])

  return null
}
